import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Component } from "react";
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

import {
  Navbar,
  Home,
  Projects,
  Contact,
  Footer,
  InfoCard,
  Writing,
} from "./imports";
import Aboutme from "./Components/Aboutme.js";
import { projectsData, projectsInfoMap } from "./data/projectsData.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectsData: projectsData
    };
  }
  render() {
    return (
      <>
        <ReactNotifications />
        <Router >
          <div id="app">
            <Switch>
              <Route exact path="/">
                <Navbar />
                <Home />
                <Projects
                  projectsData={this.state.projectsData}
                />
                <Writing />
                <Aboutme />
                <Contact />
                <Footer />
              </Route>
              {projectsInfoMap.map((index) => {
                const project = this.state.projectsData[index];
                return (
                  <Route key={project.id} exact path={project.projectInfoPath}>
                    <InfoCard
                      key={project.id}
                      name={project.name}
                      logo={project.logo}
                      demo={project.demo}
                      gitRepo={project.gitRepo}
                      previewImage={project.previewImage}
                      viewCode={project.viewCode}
                      imgAlt={project.imgAlt}
                      projectTechnologies={project.technologies}
                      projectDescription={project.projectDescription}
                      projectFunctionalities={project.functionalities}
                      projectModeling={project.modeling}
                      functionalitiesPics={project.functionalitiesPics}
                      modelingPics={project.modelingPics}
                      demoVideo={project.demoVideo}
                      backgroundPicture={project.caseStudyBackground}
                      backgrounds_attributions={project.backgroundsAttribution}
                    />
                  </Route>
                );
              })}
            </Switch>
          </div>
        </Router>
      </>
    );
  }
}

export default App;
